// Center-text sizing for InvestmentDonut. The donut hole is a function of the
// MEASURED chart size (recharts % innerRadius), so the center value/caption
// must be sized per instance — a fixed headline token overflows the hole on
// narrow cards (home span-4 squeezes the chart to ~130px).

// Hole diameter in px. recharts resolves a percent innerRadius against
// maxRadius = min(width, height) / 2, so "62%" → hole = 0.62 · min(w, h).
// A numeric innerRadius is already a radius in px.
export function donutHolePx(width, height, innerRadius) {
  const minDim = Math.min(width || 0, height || 0);
  if (typeof innerRadius === 'number') return innerRadius * 2;
  const pct = parseFloat(innerRadius);
  if (Number.isFinite(pct) && String(innerRadius).trim().endsWith('%')) {
    return (pct / 100) * minDim;
  }
  return 0.62 * minDim;
}

// Fit the value inside ~82% of the hole using the display font's ~0.58em
// average glyph width; clamp so it stays readable on tiny charts and stops
// growing on large ones. The caption scales with the hole under a hard cap.
export function donutCenterFontSizes(holePx, valueText = '') {
  const len = Math.max(3, String(valueText).length);
  const fitted = (holePx * 0.82) / (0.58 * len);
  const valuePx = Math.max(12, Math.min(30, fitted));
  const labelPx = Math.max(8, Math.min(11, holePx * 0.1));
  return { valuePx, labelPx };
}
